import { PlusOutlined } from "@ant-design/icons";
import { Col, Flex, Form, Modal, Row, Space, Button, Checkbox, DatePicker, Select } from "antd";
import { CardContainer } from "components/elements";
import { DatePickerForm, SelectForm } from "components/form";
import EmployeeEmploymentShiftTable from "components/table/EmployeeEmploymentShiftTable";
import dayjs from "dayjs";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { formatDate } from "utils/formatter";
import employeeEmploymentShift from "../schemas/employeeEmploymentShift";
import { useSelector } from "react-redux";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { FormDatePicker, FormSelect } from "components/form/FormProvide";
import { useState } from "react";
import localeTh from 'antd/es/date-picker/locale/th_TH';
import localeEn from 'antd/es/date-picker/locale/en_US';
import FormAntd from "components/form/FormProvide/FormAntd";
import { useForm } from "antd/es/form/Form";

function EmployeeEmploymentShift({
  isLoading = false,
  shiftList = [],
  pagination = {},
  isModalOpen = false,
  currentTimePlanShift = {},
  shiftOptions = [],
  onCreate = () => { },
  onEdit = () => { },
  onChange = () => { },
  onSubmit = () => { },
  onCancel = () => { },
  onDelete = () => { },
}) {

  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const { RangePicker } = DatePicker;
  const [form] = useForm();

  const formItemLayout = {
    labelAlign: "left",
    labelCol: { span: 6 },
  };

  const [assignShift, setAssignShift] = useState({
    active: false,
    open: false,
    dateActive: null
  })

  function localeFn() {
    if (i18n.language === 'en') {
      return localeEn
    } else {
      return {
        ...localeTh,
        lang: {
          ...localeTh.lang,
          yearFormat: "BBBB",
          dateFormat: "D/M/BBBB",
          cellYearFormat: "BBBB"
        }
      }
    }
  }

  return (
    <Space style={{ width: "100%" }} size={24} direction="vertical">
      <Modal
        title={currentTimePlanShift.timePlanShiftId ? t("common.edit") : t("common.create")}
        open={isModalOpen}
        onOk={() => { }}
        onCancel={() => {
          onCancel()
          form.resetFields()
        }}
        footer={
          () => {
            return (
              <Row justify={"end"} style={{ marginTop: "24px" }}>
                <Col span={12}>
                  <Space direction="horizontal" size={12}>
                    <Button
                      onClick={() => {
                        onCancel()
                        form.resetFields();
                      }}
                      style={{ borderRadius: "8px", height: "40px" }}
                      type="default"
                    >
                      {t("common.cancel")}
                    </Button>
                    <Button
                      onClick={() => {
                        form.submit();
                        form.scrollToField("shiftEndDate");
                        // console.log("form", assignShift, form.getFieldValue("shiftStartDate"));
                      }}
                      style={{ backgroundColor: "var(--button-color)", color: "var(--button-text-color)", borderRadius: "8px", height: "40px" }}
                      type="primary"
                    >
                      {t("common.submit")}
                    </Button>
                  </Space>
                </Col>
              </Row>
            )
          }
        }
        closable={false}
        maskClosable={false}
        destroyOnClose
        width={600}
      >
        <FormAntd
          {...formItemLayout}
          form={form}
          initialValues={{
            ...currentTimePlanShift,
            shift:
              i18n.language === "en"
                ? currentTimePlanShift?.shiftId?.nameEn
                : currentTimePlanShift?.shiftId?.name,
            startDate: dayjs(currentTimePlanShift?.startDate),
          }}
          onFinish={() =>
            onSubmit(form.getFieldsValue(true), form)
          }
          validationSchema={employeeEmploymentShift}
        >
          <Form.Item shouldUpdate {...formItemLayout} >
            {({ getFieldValue, setFieldValue }) => {
              return (
                <Row gutter={[0, 5]}>
                  <Col span={24}>
                    <Form.Item
                      name="shiftId"
                      label={t("team.label.shift-name")}
                      rules={[{
                        required: true,
                        message: t("team.label.please-select-shift")
                      }]}
                      colon={false}
                      {...formItemLayout}
                    >
                      <Select allowClear placeholder={t("common.pleaseSelect")} popupMatchSelectWidth={false} options={shiftOptions?.map((opt) => ({
                        ...opt,
                        label: i18n.language == "en" ? opt.nameEn : opt.name,
                        value: opt.id,
                      }))} />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item labelAlign="" {...formItemLayout} label={t("team.label.have-end-date")} name={"haveEndDate"}>
                      <Checkbox
                        // disabled={!assignShift?.value?.shiftUse?.shiftId} 
                        onChange={(e) => {
                          setFieldValue("haveEndDate", e.target.checked)
                          setFieldValue("shiftStartDate", currentTimePlanShift.startDate && dayjs(currentTimePlanShift.startDate, 'YYYY-MM-DD'))
                        }}>
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      colon={false}
                      name="shiftStartDate"
                      label={t("team.label.shift-start-date")}
                      required
                      rules={[
                        {
                          required: true,
                          message: `${t("common.pleaseSelect")} ${t("team.label.shift-start-date")}`
                        }
                      ]}
                      {...formItemLayout}
                    >
                      {!getFieldValue("haveEndDate") && <DatePicker
                        placeholder={t("common.pleaseSelect")}
                        defaultValue={currentTimePlanShift.startDate && dayjs(currentTimePlanShift.startDate, 'YYYY-MM-DD')}
                        format={i18n.language === "th" ? "DD/MM/BBBB" : "DD/MM/YYYY"}
                      />}

                      {getFieldValue("haveEndDate") &&
                        <RangePicker
                          disabled={[false, false]}
                          format={i18n.language === "th" ? "DD/MM/BBBB" : "DD/MM/YYYY"}
                          defaultValue={currentTimePlanShift.startDate && dayjs(currentTimePlanShift.startDate, 'YYYY-MM-DD')}
                          minDate={currentTimePlanShift.startDate && dayjs(currentTimePlanShift.startDate, 'YYYY-MM-DD')}
                          placeholder={[t("start-date"), t("end-date")]}
                          style={{ width: "100%" }}
                          locale={localeFn()}
                        />}
                    </Form.Item>
                  </Col>
                </Row>
              );
            }}
          </Form.Item>
        </FormAntd>
      </Modal>
      {
        roles.includes("CREATE_EMPLOYEE|EMPLOYMENT|SHIFT_INFO") &&
        <Row justify="end">
          <Button onClick={onCreate}
            style={{ width: "max-content", height: "max-content", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "10px 16px" }}
            type="primary"
          >
            <Flex align="center" justify="center" gap={8}>
              <CreateIcon />
              {t("common.create")}
            </Flex>
          </Button>
        </Row>
      }

      <EmployeeEmploymentShiftTable
        isLoading={isLoading}
        dataSource={shiftList}
        pagination={pagination}
        onChange={onChange}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </Space>
  );
}

export default EmployeeEmploymentShift;
